import { defineMessages } from 'react-intl';

export default defineMessages({
    productType: {
        id: 'ml.components.specialtyVehiclesDetails.productType',
        defaultMessage: 'Product Type'
    },
    modelYear: {
        id: 'ml.components.specialtyVehiclesDetails.modelYear',
        defaultMessage: 'Model Year'
    },
    make: {
        id: 'ml.components.specialtyVehiclesDetails.make',
        defaultMessage: 'Make'
    },
    model: {
        id: 'ml.components.specialtyVehiclesDetails.model',
        defaultMessage: 'Model'
    },
    addVehicleButton: {
        id: 'ml.components.specialtyVehiclesDetails.addVehicleButton',
        defaultMessage: 'Add Vehicle'
    },
    cancelButton: {
        id: 'ml.components.specialtyVehiclesDetails.cancelButton',
        defaultMessage: 'Cancel'
    },
    errorModalMessage: {
        id: 'ml.components.specialtyVehiclesDetails.errorModalMessage',
        defaultMessage: 'There was an error processing the request. Please try again later.'
    }
});